module.exports = __webpack_public_path__ + "static/img/HK@3x.2c64956a.jpg";